import React, { Fragment, useCallback, useMemo } from 'react';
import classNames from 'classnames';
import GutterBlockTypes from '../../../types/GutterBlockTypes';
import FirefoxSafeIcon from '../../../components/FirefoxSafeIcon';
import { GripIcon, ExpandBlockIcon, NarrowBlockIcon } from '../../../components/Icons';
import TooltipOnHover from '../../../components/TooltipOnHover';
import makeGutterBlock from '../../GutterBlockPlugin/makeGutterBlock';
var DragButton = React.memo(function (_ref) {
  var dragRef = _ref.dragRef,
      isDragging = _ref.isDragging,
      isMouseOver = _ref.isMouseOver,
      canDragOrDrop = _ref.canDragOrDrop,
      style = _ref.style,
      showGutterBlock = _ref.showGutterBlock,
      showFullWidthButton = _ref.showFullWidthButton,
      editor = _ref.editor,
      node = _ref.node;
  var actionRef = React.createRef();
  var onActionClick = useCallback(function (event) {
    return editor.command('openBlockAction', node, actionRef.current);
  }, [editor, node, actionRef]);
  var onFullWidthClick = useCallback(function (event) {
    event.preventDefault();
    editor.command('toggleFullWidth', node);
  }, [editor, node]);
  var isBlockExpanded = useMemo(function () {
    return editor.query('isBlockExpanded', node);
  }, [editor, node]);
  return showGutterBlock && React.createElement("span", {
    ref: dragRef,
    className: classNames('position-absolute block-action-wrapper transition', "block-action-wrapper--".concat(node.type), isMouseOver && 'hover'),
    style: style
  }, React.createElement("span", {
    className: classNames('block-action-button flexbox flexbox-justify-center flexbox-column transition shade-30 shade-20-on-hover', !showFullWidthButton && 'editor-line-height'),
    ref: actionRef,
    onClick: onActionClick
  }, React.createElement(TooltipOnHover, {
    disabled: isDragging,
    placement: "left",
    tooltipContent: React.createElement("span", {
      className: "font-weight-regular",
      style: {
        display: 'inline-block',
        textAlign: 'center'
      }
    }, React.createElement("span", {
      className: "font-weight-semibold"
    }, "Click"), " for options", canDragOrDrop && React.createElement(Fragment, null, React.createElement("br", null), React.createElement("span", {
      className: "font-weight-semibold"
    }, "Hold"), " to drag"))
  }, React.createElement(FirefoxSafeIcon, {
    className: "block-action-icon"
  }, React.createElement(GripIcon, null)))), showFullWidthButton && React.createElement("span", {
    className: classNames('block-action-button flexbox flexbox-justify-center flexbox-column transition shade-30 shade-20-on-hover'),
    onClick: onFullWidthClick
  }, React.createElement(TooltipOnHover, {
    key: isBlockExpanded,
    disabled: isDragging,
    placement: "left",
    tooltipContent: React.createElement("span", {
      className: "font-weight-semibold",
      style: {
        display: 'inline-block',
        textAlign: 'center'
      }
    }, isBlockExpanded ? 'Restore default-width' : 'Expand to full-width')
  }, React.createElement(FirefoxSafeIcon, {
    className: "block-action-icon"
  }, isBlockExpanded ? React.createElement(NarrowBlockIcon, null) : React.createElement(ExpandBlockIcon, null)))));
});
export default makeGutterBlock({
  gutterBlockType: GutterBlockTypes.BLOCK_ACTION
})(DragButton);